<template>
  <section class="section--resources">
    <b-container>
      <b-col class="resources" id="resources">
        <h2 class="text--center">{{ $t("science.resources") }}
            <span class="text--shadow-center">{{ $t("science.resources") }}</span>
        </h2>
        </b-col>
        <b-row class="resources__wrapper">
          <b-col cols="10" offset="1" offset-sm="0" sm="6" md="4"
            v-for="(resource, index) in resources" :key="index">
              <a class="resources__item"
                :href="domain + resource.attachment.url"
                :download="resource.description"
                target="_blank">
                  <h5 class="text--white" v-html="resource.title"></h5>
                  <p class="text--white text--small" v-html="resource.description"></p>
              </a>
          </b-col>
        </b-row>
        <b-pagination
          v-scroll-to="'#resources'"
          aria-controls="resources"
          size="md"
          :total-rows="totalRows"
          :per-page="9"
          :value=1
          @change="handlePageChange"
          class="mb-5 mt-0">
        </b-pagination>
    </b-container>
  </section>
</template>

<script>
import resources from '@/api/v1/learningResources';

export default {
  data() {
    return {
      page: 1,
      value: 1,
      isLast: true,
      resources: [],
      domain: process.env.SERVER_URL,
    };
  },
  methods: {
    getResources() {
      const succ = (response) => {
        this.resources = response.data.resources;
        this.isLast = response.data.is_last;
      };
      resources.index(this.page, succ);
    },
    handlePageChange(value) {
      this.value = value;
      this.page = value;
    },
  },
  computed: {
    totalRows() {
      if (this.isLast) {
        return this.page * 9;
      }
      return (this.page + 1) * 9;
    },
  },
  created() {
    this.getResources();
  },
  watch: {
    page() {
      this.getResources();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
@import "./src/styles/helpers/_include-media.scss";

.resources {
  margin: 92px 0 41px;
  @include media("<md") {
    margin: 40px 0;
  }
  &__wrapper {
    margin: 96px -30px 0;
    @include media("<lg") {
      margin: 0 -30px 0;
    }
  }
  &__item {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 20px 40px;
    margin-bottom: 50px;
    height: 360px;
    background-color: $color--orange;
    cursor: pointer;
    @include media("<lg") {
      height: 160px;
      margin-bottom: 30px;
      padding: 0 10px;
    }
    @include media("<md") {
      width: 250px;
      height: 250px;
      margin: 20px auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ScienceInSchool/Resources.vue